import store from '@/store'

import {API_BASE, apiErrorHandler} from '../api'
import Auth from '../auth'

const ENDPOINT = `${API_BASE}org-chart/`
const EXPENSES = `${ENDPOINT}expenses/`
const DECLINES = `${ENDPOINT}decline_reasons/`
const EVENTS = `${ENDPOINT}events/`
const NOMINATING_SUB_ORGS = `${ENDPOINT}nominating-sub-orgs/`
const METRIC_CHART_DATA = `${ENDPOINT}metric_data/`
const GOAL_PROGRESSION_DATA = `${ENDPOINT}goal_progression/`
const PROGRAM_MONTH_DATA = `${ENDPOINT}program_month/`
const PARTICIPANT_DROPOUT_DATA = `${ENDPOINT}participant_dropout/`
const PARTICIPANT_DROPOUT_REASON_DATA = `${ENDPOINT}participant_dropout_reason/`

export default class OrgChartAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new OrgChartAPI(cls)
  }

  events(organizationId, subOrgId, filter) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: this.buildFilter(subOrgId, filter),
    }

    const promise = store.state.axiosApi.get(`${EVENTS}${organizationId}/`, options)
    return promise
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.events'}))
  }

  expenses(organizationId, subOrgId, filter) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: this.buildFilter(subOrgId, filter),
    }

    const promise = store.state.axiosApi.get(`${EXPENSES}${organizationId}/`, options)
    return promise
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.expenses'}))
  }

  declines(organizationId, subOrgId, filter) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: this.buildFilter(subOrgId, filter),
    }

    const promise = store.state.axiosApi.get(`${DECLINES}${organizationId}/`, options)
    return promise
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.declines'}))
  }

  nominatingSubOrgs(organizationId, subOrgId, filter) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: this.buildFilter(subOrgId, filter),
    }

    const promise = store.state.axiosApi.get(`${NOMINATING_SUB_ORGS}${organizationId}/`, options)

    return promise
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.nominatingSubOrgs'}))
  }

  tcrGoalProgressChartData() {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = store.state.axiosApi.get(`${GOAL_PROGRESSION_DATA}`, options)

    return promise
      .then(res => res.data)
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.goal_progression'}))
  }

  tcrProgramMonthChartData() {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = store.state.axiosApi.get(`${PROGRAM_MONTH_DATA}`, options)

    return promise
      .then(res => res.data)
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.program_month'}))
  }

  tcrParticipantDropoutChartData() {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = store.state.axiosApi.get(`${PARTICIPANT_DROPOUT_DATA}`, options)
      .then(res => res.data)
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.participant_dropout'}))
    return promise
  }

  tcrParticipantDropoutReasonChartData() {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const promise = store.state.axiosApi.get(`${PARTICIPANT_DROPOUT_REASON_DATA}`, options)
      .then(res => res.data)
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.participant_dropout_reason'}))
    return promise
  }

  metricChartData(organizationId, subOrgId, metric, timeframe, dateInformation = {}) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }

    const dateInformationParams = new URLSearchParams(dateInformation).toString()
    const promise = store.state.axiosApi.get(
        `${METRIC_CHART_DATA}${organizationId}/?metric=${metric}&timeframe=${timeframe}&${dateInformationParams}`,
        options,
      )

    return promise
      .then(res => res.data)
      .catch(apiErrorHandler({apiName: 'OrganizationChartAPI.declines'}))
  }

  buildFilter(subOrgId, filter) {
    let params = filter
      ? Object.assign(
        {},
        {
          // Send the dates in YYYY-MM-DD format with no timezone
          startDate: filter.startDate.toISOString().split('T')[0],
          endDate: filter.endDate.toISOString().split('T')[0],
        },
      )
      : {}

    params = {...params, suborganization_id: subOrgId}

    return params
  }
}
